// extracted by mini-css-extract-plugin
module.exports = {"chatInput":"ChatGptDrawer_chatInput__2Nxsv","messages":"ChatGptDrawer_messages__1GUfl","drawerFooter":"ChatGptDrawer_drawerFooter__nz4PW","welcome":"ChatGptDrawer_welcome__rmnB6"};